export class PCXKeyValue {
    Key: string;
    Value: string;
}
